module.exports = __webpack_public_path__ + "static/media/logo_inverted.85f8350b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/logo_inverted.svg
// module id = 586
// module chunks = 7